import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useEmailValidation = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const { t } = useTranslation();

  const handleEmailChange = (value) => {
    setEmail(value);
    if (value === '') {
      setEmailError(t("signUp.validate.empty.email"));
    } else {
      validateEmail(value);
    }
  };

  const validateEmail = (email) => {
    // regex allowing only alphanumeric characters, periods, underscores, and dashes in the local part
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(email)) {
      setEmailError(t("signUp.validate.verifyEmail"));
    } else {
      setEmailError('');
    }
  };

  return {
    email,
    setEmail,
    setEmailError,
    emailError,
    handleEmailChange,
  };
};

export default useEmailValidation;
